/*
 * Copyright © 2026 Medaica, Inc
 *
 * All rights reserved.
 *
 * This code is confidential and proprietary information belonging to Medaica, Inc.
 * Unauthorized copying, distribution, or use of this code, in whole or in part,
 * is strictly prohibited, and may constitute a violation of intellectual property rights.
 *
 * If you have received this code in error, please notify the owner immediately
 * at support@medaica.com and delete this file from your system.
 */

import React, { ReactElement } from "react"
import { ExamDemographics } from "../exam-demographics"

const Fact = ({ label, value }: { label: string; value?: string | number | null }): ReactElement => (
  <div className="exam-fact">
    <dt className="exam-fact-label">{label}</dt>
    <dd className="exam-fact-value">{value === undefined || value === null || value === "" ? "—" : String(value)}</dd>
  </div>
)

/**
 * The identity strip at the top right of the Medaica Viewer workspace: the
 * patient's name, date of birth, age, sex and the exam date, in the same
 * label-over-value style as the standalone viewer's header strip.
 */
const ExamFacts = ({ demographics }: { demographics: ExamDemographics }): ReactElement => (
  <dl className="exam-facts" data-testid="exam-facts">
    <Fact label="Name" value={demographics.patientName} />
    <Fact label="DOB" value={demographics.dob} />
    <Fact label="Age" value={demographics.age} />
    <Fact label="Sex" value={demographics.sex} />
    <Fact label="Exam date" value={demographics.examDate} />
  </dl>
)

export default ExamFacts
